import { useEffect } from "react";

const ScrollToToday = () => {
    useEffect(() => {
        setTimeout(() => {
          const today = new Date();
          const month = String(today.getMonth() + 1).padStart(2, "0");
          const day = String(today.getDate()).padStart(2, "0");
          const year = today.getFullYear();
          const todayId = `${month}/${day}/${year}`;
          const el = document.getElementById(todayId);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 3000); // Delay para garantir que tudo foi renderizado
      }, []);
      

  return null;
};

export default ScrollToToday;
 